import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { uniq } from "lodash";
import { Grid } from "semantic-ui-react";
import GuaranteeDocumentsDetails from "./guaranteeDocumentsDetails";

function GuaranteeForm(props) {


  const warranties = useSelector((state) => state.Shipment.warranties);

  let uniquemerch = uniq(warranties);
  const {

    isFormDisabled,
  } = props;

 

  const printSupportingDocs = uniquemerch.map((item, index) => (
    <GuaranteeDocumentsDetails
    key={index}
      infoIndex={index}
      warrantyId= {item.warrantyId}
    isFormDisabled={isFormDisabled}
      totalInfo={uniquemerch.length}
    />
  ));

  const SupportingDocsList = useMemo(
    () => printSupportingDocs,
    [warranties.length,isFormDisabled]
  );

  return  <Grid>{SupportingDocsList}</Grid>;
}
export default React.memo(GuaranteeForm)
